export default class Preferences {

	public constructor (private reviewReminders: boolean | null) {}

	public changeReviewReminders (value: boolean) {
		this.reviewReminders = value;
	}

	public shouldSendReviewReminders () {
		return this.reviewReminders === true;
	}

	public reviewRemindersIsSet () {
		return this.reviewReminders !== null;
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/users/domain/aggregates/user/Preferences.ts